var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1127 12.0007C11.1127 12.2365 11.2064 12.4625 11.3731 12.6292C11.5398 12.7959 11.7659 12.8896 12.0016 12.8896C12.2374 12.8896 12.4635 12.7959 12.6302 12.6292C12.7969 12.4625 12.8905 12.2365 12.8905 12.0007C12.8905 11.765 12.7969 11.5389 12.6302 11.3722C12.4635 11.2055 12.2374 11.1118 12.0016 11.1118C11.7659 11.1118 11.5398 11.2055 11.3731 11.3722C11.2064 11.5389 11.1127 11.765 11.1127 12.0007Z",
    stroke: "#D35258",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0015 7.55518C11.1226 7.55518 10.2635 7.81579 9.53273 8.30406C8.80199 8.79233 8.23244 9.48632 7.89611 10.2983C7.55979 11.1102 7.47179 12.0037 7.64325 12.8657C7.8147 13.7277 8.23792 14.5194 8.85936 15.1409C9.48081 15.7623 10.2726 16.1855 11.1346 16.357C11.9965 16.5285 12.89 16.4405 13.702 16.1041C14.5139 15.7678 15.2079 15.1983 15.6962 14.4675C16.1845 13.7368 16.4451 12.8776 16.4451 11.9988",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8902 4.05134C11.2426 3.86649 9.57825 4.19822 8.1274 5.00064C6.67655 5.80306 5.5109 7.03651 4.79171 8.53036C4.07252 10.0242 3.83532 11.7046 4.11292 13.3392C4.39053 14.9738 5.16922 16.4817 6.34128 17.6543C7.51335 18.827 9.02085 19.6064 10.6553 19.8848C12.2897 20.1633 13.9702 19.9269 15.4644 19.2085C16.9587 18.49 18.1927 17.325 18.9958 15.8746C19.799 14.4241 20.1316 12.7599 19.9476 11.1122",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6677 6.6686V9.33476H17.3339L20 6.6686H17.3339V4.00244L14.6677 6.6686Z",
    stroke: "#D35258",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6689 9.33545L12.0022 12.0021",
    stroke: "#D35258",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadIn);
export default __webpack_public_path__ + "static/media/LoadIn.eca53c86a5e1495dc43ff1043e6f5388.svg";
export { ForwardRef as ReactComponent };